import { jsx as _jsx } from "react/jsx-runtime";
export var DefaultNotFound = function DefaultNotFound() {
  return /*#__PURE__*/_jsx("div", {
    style: {
      margin: '150px auto',
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    children: "404"
  });
};